import Image from 'next/image'
import { UseRecurlyInstance } from '@recurly/react-recurly'
import { useEffect } from 'react'

interface propTypes {
  recurly: UseRecurlyInstance
  update: Function
}

const PayPalButton = (props: propTypes) => {
  const { recurly, update } = props
  const payPal = recurly.PayPal({
    display: {
      displayName: 'Reason Studios',
    },
  })

  useEffect(() => {
    payPal.on('token', (token) => {
      update(token)
    })
    payPal.on('error', (error) => {
      throw error
    })
    payPal.on('cancel', () => {
      console.log('Cancelled')
    })
    payPal.on('ready', () => {
      console.log('Ready')
    })
  }, [payPal, update])
  const handleClick = () => {
    payPal.start()
  }
  return (
    <div onClick={handleClick}>
      <img
        src={`/logos/paypal.svg`}
        alt="credit card logotype"
        width="175"
        height="45"
      />
    </div>
  )
}

export default PayPalButton
